import React, { createContext, useState, useContext, useEffect } from 'react';
import apiClient from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, check token and fetch admin details if token exists
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
      // Fetch admin details to populate user state correctly
      apiClient.get('/users/me/admin') // Use the admin-specific endpoint
        .then(response => {
          // Assuming the response has an 'email' field
          setUser({
            email: response.data.email,
            username: response.data.email, // Use email as username for display
            isAdmin: true, // Indicate it's an admin
            // Add other relevant details from response if needed (like last_login)
            last_login: response.data.last_login
          });
        })
        .catch(error => {
          // Token might be invalid or expired
          console.error('Error fetching admin details on load:', error);
          localStorage.removeItem('token'); // Clear invalid token
          delete apiClient.defaults.headers.common.Authorization;
          setUser(null);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false); // No token found, loading finished
    }
  }, []); // Run only once on mount

  // Login function specifically for Admins
  const login = async (username, password) => { // 'username' here is the email input
    try {
      const response = await apiClient.post('/token', {
        username,
        password,
      }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });

      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      apiClient.defaults.headers.common.Authorization = `Bearer ${access_token}`;

      // --- FIX: Set user state with username property ---
      setUser({
          email: username,      // Store the email
          username: username,   // Use email as the username for display purposes
          isAdmin: true       // Indicate admin status
      });
      // --- End Fix ---

      console.log("Admin login successful.");
      return true;

    } catch (error) {
      console.error('Admin Login error:', error);
      localStorage.removeItem('token');
      delete apiClient.defaults.headers.common.Authorization;
      setUser(null);
      return false;
    }
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('token');
    delete apiClient.defaults.headers.common.Authorization;
    setUser(null);
    // Consider redirecting to login page here if not handled by routing
  };

  const value = {
    user,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {/* Render children only after initial loading check is complete */}
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);